import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Routes, Route, BrowserRouter } from "react-router-dom";
import AdminShell from './Components/AdminShell';
import Dashboard from './Pages/Dashboard';
import Login from './Pages/Login';
import ResetPassword from './Pages/ResetPassword';
import TheSMS from './Pages/TheSMS';
import Applications from './Pages/Applications';
import ApplicationsAwaitingJoin from './Pages/ApplicationsAwaitingJoin';
import Interviews from './Pages/Interviews';
import Invoicing from './Pages/Invoicing';
import Profile from './Pages/Profile';
import HelpSupport from './Pages/HelpSupport';
import Settings from './Pages/Settings';
import ActivityLogs from './Pages/ActivityLogs';
import Admins from './Pages/Admins';
import ActiveStudents from './Pages/ActiveStudents';
import SecondaryCourses from './Pages/SecondaryCourses';
import GraduatedStudents from './Pages/GraduatedStudents';
import LearningBreaks from './Pages/LearningBreaks';
import NeverJoined from './Pages/NeverJoined';
import OtherStudents from './Pages/OtherStudents';
import StudentsGraduating from './Pages/StudentsGraduating';
import FeeReminders from './Pages/FeeReminders';
import MediaConsent from './Pages/MediaConsent';
import MediaConsentNew from './Pages/MediaConsentNew';
import MediaConsentResponse from './Pages/MediaConsentResponse';
import LegalDocs from './Pages/LegalDocs';
import BusinessBankingDetails from './Pages/BusinessInfo/BusinessBankingDetails';
import BusinessMpesaDetails from './Pages/BusinessInfo/BusinessMpesaDetails';
import ExchangeRateInfo from './Pages/BusinessInfo/ExchangeRateInfo';
import PaybillBalance from './Pages/BusinessInfo/PaybillBalance';
import DocumentGenerator from './Pages/BusinessInfo/DocumentGenerator';
import GeneratedDocuments from './Pages/BusinessInfo/GeneratedDocuments';
import GeneratedDocumentView from './Pages/BusinessInfo/GeneratedDocumentView';
import StrategicRoadmap from './Pages/StrategicRoadmap';
import TheEmails from './Pages/TheEmails';
import ViewStudent from './Pages/ViewStudent';
import Income from './Pages/Finance/Income';
import AdmissionFees from './Pages/Finance/AdmissionFees';
import StudentDiscounts from './Pages/Finance/StudentDiscounts';
import DirectExpenses from './Pages/Finance/DirectExpenses';
import PaymentAudit from './Pages/Finance/PaymentAudit';
import Invoices from './Pages/Finance/Invoices';
import ProjectedIncome from './Pages/Finance/ProjectedIncome';
import BalanceSheet from './Pages/Finance/BalanceSheet';
import ViewInvoice from './Pages/Finance/ViewInvoice';
import ViewFixedBill from './Pages/Finance/ViewFixedBill';
import Branches from './Pages/Branches';
import OtherIncome from './Pages/Finance/OtherIncome';
import Vendors from './Pages/Finance/Vendors';
import ViewVendor from './Pages/Finance/ViewVendor';
import VendorSectionPage from './Pages/Finance/VendorSectionPage';
import Bills from './Pages/Finance/Bills';
import PayBills from './Pages/Finance/PayBills';
import Requisitions from './Pages/Finance/Requisitions';
import RequisitionApprovals from './Pages/Finance/RequisitionApprovals';
import StatutoryRemittances from './Pages/Finance/StatutoryRemittances';
import Debts from './Pages/Finance/Debts';
import FinanceReports from './Pages/Finance/FinanceReports';
import AssetRegister from './Pages/Finance/AssetRegister';
import Employees from './Pages/HR/Employees';
import PaySalaries from './Pages/HR/PaySalaries';
import PayrollLedger from './Pages/HR/PayrollLedger';
import ViewEmployee from './Pages/HR/ViewEmployee';
import EmployeeSectionPage from './Pages/HR/EmployeeSectionPage';
import Courses from './Pages/Academic/Courses';
import CourseDetails from './Pages/Academic/CourseDetails';
import Intakes from './Pages/Academic/Intakes';
import Classess from './Pages/Academic/Classess';
import Darassa from './Pages/Academic/Darassa';
import ViewAllClasses from './Pages/Academic/ViewAllClasses';
import AddIncome from './Pages/Finance/AddIncome';
import AddInvoice from './Pages/Finance/AddInvoice';
import ViewReceipt from './Pages/Finance/ViewReceipt';
import Certificate from './Pages/Certificate';
import SchoolId from './Pages/SchoolIdComp';
import StudentTraineeLetter from './Pages/StudentTraineeLetter';

// 
import MarketingBudget from './Pages/Marketing/MarketingBudget';
import MarketingExpenses from './Pages/Marketing/MarketingExpenses';
import StudentSources from './Pages/Analytics/StudentSources';
import ConvBySource from './Pages/Analytics/ConvBySource';
import TrendsOverTime from './Pages/Analytics/TrendsOverTime';
import CourseBySource from './Pages/Analytics/CourseBySource';
import DemographicsBySource from './Pages/Analytics/DemographicsBySource';
import SessionTimeDemand from './Pages/Analytics/SessionTimeDemand';
import ApplicationToAdmTime from './Pages/Analytics/ApplicationToAdmTime';
import CampusType from './Pages/Analytics/CampusType';
import DropOffAnalysis from './Pages/Analytics/DropOffAnalysis';
import DistributionByCountry from './Pages/Analytics/DistributionByCountry';
import CountryAnalysis from './Pages/Analytics/CountryAnalysis';
import AndroidAppActivity from './Pages/Analytics/AndroidAppActivity';
import ActiveAttendanceStudents from './Pages/Analytics/ActiveAttendanceStudents';
import InactiveAttendanceStudents from './Pages/Analytics/InactiveAttendanceStudents';
import IntakeSuccessAnalysis from './Pages/Analytics/IntakeSuccessAnalysis';
import ActiveStudentsWithClearedFees from './Pages/Analytics/ActiveStudentsWithClearedFees';
import ActiveStudentsWithUnclearedFees from './Pages/Analytics/ActiveStudentsWithUnclearedFees';
import ActiveStudentsPayingFees from './Pages/Analytics/ActiveStudentsPayingFees';
import ActiveStudentsNotPayingFees from './Pages/Analytics/ActiveStudentsNotPayingFees';
import FeeCollectionStanding from './Pages/Analytics/FeeCollectionStanding';
import DailyAttendanceRegister from './Pages/Analytics/DailyAttendanceRegister';
import VisitorJourneyIntelligence from './Pages/Analytics/VisitorJourneyIntelligence';
import Devs from './Pages/Lab/Devs';
import ExtendedTeams from './Pages/Lab/ExtendedTeams';
import ManagedService from './Pages/Lab/ManagedService';
import ManagedProduct from './Pages/Lab/ManagedProduct';
import LabOnboarding from './Pages/Lab/LabOnboarding';
import ViewLabClient from './Pages/Lab/ViewLabClient';
import LabEmails from './Pages/Lab/LabEmails';
import InterviewMeetingPage from './Pages/InterviewMeetingPage';
import JobsScout from './Pages/JobsScout';
import JobsScoutJobView from './Pages/JobsScoutJobView';
import GrowthScout from './Pages/GrowthScout';
import GrowthOpportunityView from './Pages/GrowthOpportunityView';
import NewsPosts from './Pages/NewsPosts';
import NewsPostEditor from './Pages/NewsPostEditor';
import ProtectedRoute from './ProtectedRoute';





function App() {
  const withRoles = (element, allowedAdminTypes = ['admin', 'superAdmin']) => (
    <ProtectedRoute allowedAdminTypes={allowedAdminTypes}>
      {element}
    </ProtectedRoute>
  );


  return (
    <div className="App">   
      <BrowserRouter>
        <Routes>

          <Route path="/" element={<Login />} />
          <Route path="/login" element={<Login />} />
          <Route path="/reset-password" element={<ResetPassword />} />


          <Route path="/view-receipt" element={withRoles(<ViewReceipt />)} />
          <Route path="/view-invoice" element={withRoles(<ViewInvoice />)} />
          <Route path="/media-consent/respond/:token" element={<MediaConsentResponse />} />
          <Route path="/meeting/:meetingId" element={<InterviewMeetingPage />} />


          <Route element={<AdminShell />}>
            {/* Activate during development */}
            <Route path="/dashboard" element={withRoles(<Dashboard />)} />
            <Route path="/interviews" element={withRoles(<Interviews />)} />
            <Route path="/invoicing" element={withRoles(<Invoicing />)} />
            <Route path="/profile" element={withRoles(<Profile />)} />
            <Route path="/help-support" element={withRoles(<HelpSupport />)} />
            <Route path="/activity-logs" element={withRoles(<ActivityLogs />, ['superAdmin'])} />
            <Route path="/settings" element={withRoles(<Settings />, ['superAdmin'])} />
            <Route path="/admins" element={withRoles(<Admins />, ['superAdmin'])} />

            <Route path="/courses" element={withRoles(<Courses />, ['superAdmin'])} />
            <Route path="/course-details/:courseId" element={withRoles(<CourseDetails />, ['superAdmin'])} />
            <Route path="/intakes" element={withRoles(<Intakes />)} />
            <Route path="/classes" element={withRoles(<Classess />)} />
            <Route path="/branches" element={withRoles(<Branches />, ['superAdmin'])} />
            <Route path="/darasa" element={withRoles(<Darassa />)} />

            <Route path="/applications" element={withRoles(<Applications />)} />
            <Route path="/applications-awaiting-join" element={withRoles(<ApplicationsAwaitingJoin />)} />
            <Route path="/active-students" element={withRoles(<ActiveStudents />)} />
            <Route path="/secondary-courses" element={withRoles(<SecondaryCourses />)} />
            <Route path="/learning-breaks" element={withRoles(<LearningBreaks />)} />
            <Route path="/graduated-students" element={withRoles(<GraduatedStudents />)} />
            <Route path="/students-graduating" element={withRoles(<StudentsGraduating />)} />
            <Route path="/never-joined" element={withRoles(<NeverJoined />)} />
            <Route path="/other-students" element={withRoles(<OtherStudents />)} />

            <Route path="/sms" element={withRoles(<TheSMS />)} />
            <Route path="/emails" element={withRoles(<TheEmails />)} />
            <Route path="/fee-reminders" element={withRoles(<FeeReminders />)} />
            <Route path="/media-consent" element={withRoles(<MediaConsent />)} />
            <Route path="/media-consent/new" element={withRoles(<MediaConsentNew />)} />
            <Route path="/legal-docs" element={withRoles(<LegalDocs />)} />
            <Route path="/document-generator" element={withRoles(<DocumentGenerator />)} />
            <Route path="/generated-documents" element={withRoles(<GeneratedDocuments />)} />
            <Route path="/generated-documents/:documentId" element={withRoles(<GeneratedDocumentView />)} />
            <Route path="/banking-details" element={withRoles(<BusinessBankingDetails />)} />
            <Route path="/mpesa-details" element={withRoles(<BusinessMpesaDetails />)} />
            <Route path="/exchange-rate-info" element={withRoles(<ExchangeRateInfo />)} />
            <Route path="/paybill-balance" element={withRoles(<PaybillBalance />)} />
            <Route path="/strategic-roadmap" element={withRoles(<StrategicRoadmap />)} />

            <Route path="/income" element={withRoles(<Income />)} />
            <Route path="/admission-fees" element={withRoles(<AdmissionFees />)} />
            <Route path="/student-discounts" element={withRoles(<StudentDiscounts />)} />
            <Route path="/direct-expenses" element={withRoles(<DirectExpenses />, ['superAdmin'])} />
            <Route path="/payment-audit" element={withRoles(<PaymentAudit />)} />
            <Route path="/sent-invoices" element={withRoles(<Invoices />)} />
            <Route path="/projected-income" element={withRoles(<ProjectedIncome />, ['superAdmin'])} />
            <Route path="/balance-sheet" element={withRoles(<BalanceSheet />, ['superAdmin'])} />
            <Route path="/other-income" element={withRoles(<OtherIncome />, ['superAdmin'])} />
            <Route path="/vendors" element={withRoles(<Vendors />, ['superAdmin'])} />
            <Route path="/view-vendor/:id" element={withRoles(<ViewVendor />, ['superAdmin'])} />
            <Route path="/view-vendor/:id/payments" element={withRoles(<VendorSectionPage section="payments" />, ['superAdmin'])} />
            <Route path="/view-vendor/:id/change-logs" element={withRoles(<VendorSectionPage section="changeLogs" />, ['superAdmin'])} />
            <Route path="/view-vendor/:id/related-bills" element={withRoles(<VendorSectionPage section="relatedBills" />, ['superAdmin'])} />
            <Route path="/fixed-bills" element={withRoles(<Bills />, ['superAdmin'])} />
            <Route path="/pay-bills" element={withRoles(<PayBills />, ['superAdmin'])} />
            <Route path="/requisitions" element={withRoles(<Requisitions />)} />
            <Route path="/requisition-approvals" element={withRoles(<RequisitionApprovals />, ['superAdmin'])} />
            <Route path="/statutory-remittances" element={withRoles(<StatutoryRemittances />, ['superAdmin'])} />
            <Route path="/debts-loans" element={withRoles(<Debts />, ['superAdmin'])} />
            <Route path="/finance-reports" element={withRoles(<FinanceReports />, ['superAdmin'])} />
            <Route path="/assets" element={withRoles(<AssetRegister />, ['superAdmin'])} />
            <Route path="/add-income" element={withRoles(<AddIncome />)} />
            <Route path="/send-invoice" element={withRoles(<AddInvoice />)} />
            <Route path="/employees" element={withRoles(<Employees />, ['superAdmin'])} />
            <Route path="/pay-salaries" element={withRoles(<PaySalaries />, ['superAdmin'])} />
            <Route path="/cash-salary-payments" element={withRoles(<PaySalaries cashOnly />, ['superAdmin'])} />
            <Route path="/payroll-ledger" element={withRoles(<PayrollLedger />, ['superAdmin'])} />
            <Route path="/view-employee/:id" element={withRoles(<ViewEmployee />, ['superAdmin'])} />
            <Route path="/view-employee/:id/leave-requests" element={withRoles(<EmployeeSectionPage section="leaveRequests" />, ['superAdmin'])} />
            <Route path="/view-employee/:id/salary-payments" element={withRoles(<EmployeeSectionPage section="salaryPayments" />, ['superAdmin'])} />
            <Route path="/view-employee/:id/activity-logs" element={withRoles(<EmployeeSectionPage section="activityLogs" />, ['superAdmin'])} />
            <Route path="/view-employee/:id/teaching-sessions" element={withRoles(<EmployeeSectionPage section="teachingSessions" />, ['superAdmin'])} />
            <Route path="/view-employee/:id/check-ins" element={withRoles(<EmployeeSectionPage section="checkIns" />, ['superAdmin'])} />
            <Route path="/view-employee/:id/disciplinary-records" element={withRoles(<EmployeeSectionPage section="disciplinaryRecords" />, ['superAdmin'])} />


            {/* new stuff */}
            <Route path="/fee-balances" element={withRoles(<FeeReminders />)} />
            <Route path="/marketing-budget" element={withRoles(<MarketingBudget />, ['superAdmin'])} />
            <Route path="/marketing-expenses" element={withRoles(<MarketingExpenses />, ['superAdmin'])} />
            <Route path="/jobs-scout" element={withRoles(<JobsScout />, ['superAdmin'])} />
            <Route path="/jobs-scout/:jobId" element={withRoles(<JobsScoutJobView />, ['superAdmin'])} />
            <Route path="/growth-opportunity-scout" element={withRoles(<GrowthScout />, ['superAdmin'])} />
            <Route path="/growth-opportunity-scout/:opportunityId" element={withRoles(<GrowthOpportunityView />, ['superAdmin'])} />
            <Route path="/news-posts" element={withRoles(<NewsPosts />, ['superAdmin'])} />
            <Route path="/news-posts/new" element={withRoles(<NewsPostEditor />, ['superAdmin'])} />
            <Route path="/news-posts/edit/:postId" element={withRoles(<NewsPostEditor />, ['superAdmin'])} />

            {/*Analytics */}
            <Route path="/sources-of-students" element={withRoles(<StudentSources />, ['superAdmin'])} />
            <Route path="/conversion-by-source" element={withRoles(<ConvBySource />, ['superAdmin'])} />
            <Route path="/trends-over-time" element={withRoles(<TrendsOverTime />, ['superAdmin'])} />
            <Route path="/course-by-source" element={withRoles(<CourseBySource />, ['superAdmin'])} />
            <Route path="/demographics-by-source" element={withRoles(<DemographicsBySource />, ['superAdmin'])} />
            <Route path="/session-time-demand" element={withRoles(<SessionTimeDemand />, ['superAdmin'])} />
            <Route path="/application-to-adm-time" element={withRoles(<ApplicationToAdmTime />, ['superAdmin'])} />
            <Route path="/campus-type" element={withRoles(<CampusType />, ['superAdmin'])} />
            <Route path="/drop-off-analysis" element={withRoles(<DropOffAnalysis />, ['superAdmin'])} />
            <Route path="/visitor-journey" element={withRoles(<VisitorJourneyIntelligence />, ['superAdmin'])} />
            <Route path="/distribution-by-country" element={withRoles(<DistributionByCountry />, ['superAdmin'])} />
            <Route path="/country-analysis" element={withRoles(<CountryAnalysis />, ['superAdmin'])} />
            <Route path="/android-app-activity" element={withRoles(<AndroidAppActivity />, ['superAdmin'])} />
            <Route path="/active-attendance-students" element={withRoles(<ActiveAttendanceStudents />, ['superAdmin'])} />
            <Route path="/inactive-attendance-students" element={withRoles(<InactiveAttendanceStudents />, ['superAdmin'])} />
            <Route path="/intake-success-analysis" element={withRoles(<IntakeSuccessAnalysis />, ['superAdmin'])} />
            <Route path="/active-students-with-cleared-fees" element={withRoles(<ActiveStudentsWithClearedFees />, ['superAdmin'])} />
            <Route path="/active-students-with-uncleared-fees" element={withRoles(<ActiveStudentsWithUnclearedFees />, ['superAdmin'])} />
            <Route path="/active-students-paying-fees" element={withRoles(<ActiveStudentsPayingFees />, ['superAdmin'])} />
            <Route path="/active-students-not-paying-fees" element={withRoles(<ActiveStudentsNotPayingFees />, ['superAdmin'])} />
            <Route path="/fee-collection-standing" element={withRoles(<FeeCollectionStanding />, ['superAdmin'])} />
            <Route path="/daily-attendance-register" element={withRoles(<DailyAttendanceRegister />, ['superAdmin'])} />
            <Route path="/view-student" element={withRoles(<ViewStudent />)} />
            <Route path="/view-certificate" element={withRoles(<Certificate />)} />
            <Route path="/view-school-id" element={withRoles(<SchoolId />)} />
            <Route path="/view-student-trainee-letter" element={withRoles(<StudentTraineeLetter />)} />
            <Route path="/view-classes" element={withRoles(<ViewAllClasses />)} />
            <Route path="/view-fixed-bill/:id" element={withRoles(<ViewFixedBill />, ['superAdmin'])} />

            {/* LAB */}
            <Route path="/devs" element={withRoles(<Devs/>, ['superAdmin'])} />
            <Route path="extended-teams" element={withRoles(<ExtendedTeams/>, ['superAdmin'])} />
            <Route path="managed-service" element={withRoles(<ManagedService/>, ['superAdmin'])} />
            <Route path="managed-products" element={withRoles(<ManagedProduct/>, ['superAdmin'])} />
            <Route path="lab-onboarding" element={withRoles(<LabOnboarding/>, ['superAdmin'])} />
            <Route path="view-lab-client/:id" element={withRoles(<ViewLabClient/>, ['superAdmin'])} />
            <Route path="lab-emails" element={withRoles(<LabEmails/>, ['superAdmin'])} />
          </Route>
          <Route path="/:meetingId" element={<InterviewMeetingPage />} />


        </Routes>       
      </BrowserRouter> 
    </div>
  );
}

export default App;
